import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, supersetUrl } from '../../../../../../Containers/Config/index.js';
import {
  SUPERSET_CSAT_CUSTOMER_FEEDBACKS,
  SUPERSET_CSAT_CUSTOMER_FEEDBACKS_ERROR,
  SUPERSET_CSAT_CUSTOMER_FEEDBACKS_SUCCESS,
} from '../../../../actionType.js';
import apiCall from '../../../../apiCall.js';

function* supersetCSATCustomerFeedbacks({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${supersetUrl}/api/v1/chart/data`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
        ...payload?.headers,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: SUPERSET_CSAT_CUSTOMER_FEEDBACKS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: SUPERSET_CSAT_CUSTOMER_FEEDBACKS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SUPERSET_CSAT_CUSTOMER_FEEDBACKS_ERROR, payload: error });
  }
}

export function* watchSupersetCSATCustomerFeedbacks() {
  yield takeEvery(SUPERSET_CSAT_CUSTOMER_FEEDBACKS, supersetCSATCustomerFeedbacks);
}

function* supersetCSATCustomerFeedbacksSaga() {
  yield all([fork(watchSupersetCSATCustomerFeedbacks)]);
}

export default supersetCSATCustomerFeedbacksSaga;
